import { useSiteSetupActions } from "@inrange/building-manager-api-client";
import {
  getESysName,
  SiteElectricalSystem,
} from "@inrange/building-manager-api-client/models-site";
import { Badge, Button, Spinner } from "react-bootstrap";

const DataIngestionConfigSection = ({
  esysEntries,
  ingestionByEsys,
  onConfigureEsys,
}: {
  esysEntries: [string, SiteElectricalSystem][];
  ingestionByEsys: ReturnType<typeof useSiteSetupActions>["ingestionByEsys"];
  onConfigureEsys: (esysUuid: string) => void;
}) => {
  return (
    <div>
      <h6 className="fw-bold mb-2">Data ingestion config</h6>
      <div className="d-flex flex-column gap-2">
        {esysEntries.map(([key, esys]) => {
          const typedEsys = esys as SiteElectricalSystem;
          const ingestionQuery = ingestionByEsys[typedEsys.uuid];
          const esysLabel =
            esysEntries.length > 1
              ? `Energy match${getESysName(esysEntries.length, typedEsys)}`
              : null;

          if (ingestionQuery?.isLoading) {
            return (
              <div key={key} className="d-flex align-items-center gap-2">
                {esysLabel && <span className="fw-semibold">{esysLabel}:</span>}
                <Spinner animation="border" size="sm" />
              </div>
            );
          }

          if (ingestionQuery?.isError) {
            return (
              <div key={key} className="d-flex align-items-center gap-2">
                {esysLabel && <span className="fw-semibold">{esysLabel}:</span>}
                <Badge bg="danger">Error loading</Badge>
              </div>
            );
          }

          const esysConfig = ingestionQuery?.data ?? null;
          const isConfigured =
            esysConfig && !!esysConfig.site.has_monitoring_config;

          return (
            <div key={key} className="d-flex align-items-center gap-2">
              {esysLabel && <span className="fw-semibold">{esysLabel}:</span>}
              {!isConfigured ? (
                <>
                  <Badge bg="warning" text="dark">
                    Not configured
                  </Badge>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => onConfigureEsys(typedEsys.uuid)}
                  >
                    Configure
                  </Button>
                </>
              ) : (
                <>
                  <Badge bg="success">Configured</Badge>
                  {esysConfig.site.solaredge_site_id && (
                    <Badge bg="secondary">
                      SolarEdge API {esysConfig.site.solaredge_api_mode ?? "v1"}
                    </Badge>
                  )}
                  <Button
                    variant="secondary"
                    size="sm"
                    onClick={() => onConfigureEsys(typedEsys.uuid)}
                  >
                    Edit
                  </Button>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DataIngestionConfigSection;
